import { createStep } from './rocket-configs';
import { getPeople } from '@/features/people/api';
import { getJourneysWorkspace } from '@/features/journeys-workspace/api';
import { getSegments } from '@/features/segments/api';
import { Link, Text } from '@customerio/pluma-components/react';

export const UNDERSTAND_YOUR_AUDIENCE_STEPS = [
  createStep({
    id: 'people',
    ariaLabel: 'Add people',
    content: 'Add people',
    queryFn: getPeople,
    completion: (data) => (data?.customers?.length ?? 0) / 4,
    modelId: 'people_rocket_added_people_at',
    tooltip: 'Add at least 4 people to complete',
    href: 'people/create',
  }),
  createStep({
    id: 'journeys',
    ariaLabel: 'Add one custom attribute',
    content: (
      <Text>
        Add one custom{' '}
        <Link
          isUnderlined={true}
          href="https://docs.customer.io/journeys/attributes/"
          isExternal={true}
          icon="exit"
          iconPosition="trailing"
          aria-label="See documentation for custom attributes"
        >
          attribute
        </Link>
      </Text>
    ),
    queryFn: getJourneysWorkspace,
    completion: (data) => {
      if (data == null) {
        return 0;
      }
      const attributes = data.environment.sent_attributes ?? [];
      const DEFAULT_ATTRIBUTES = ['cio_id', 'created_at', 'email', 'id', '_created_in_customerio_at'];
      const nonDefaultAttributes = attributes.filter((attr: string) => !DEFAULT_ATTRIBUTES.includes(attr));

      return nonDefaultAttributes.length;
    },
    href: 'people',
    modelId: 'people_rocket_added_attribute_at',
  }),
  createStep({
    id: 'segments',
    ariaLabel: 'Create a segment',
    content: (
      <Text>
        Create a{' '}
        <Link
          isUnderlined={true}
          href="https://docs.customer.io/journeys/segments/"
          isExternal={true}
          icon="exit"
          iconPosition="trailing"
          aria-label="See documentation for segments"
        >
          segment
        </Link>
      </Text>
    ),
    queryFn: getSegments,
    completion: (data) => {
      if (data == null) {
        return 0;
      }
      const { tags, segments } = data;
      const sampleTag = tags.find((tag) => tag.name === 'Sample');
      const nonSampleSegments = segments.filter(
        (segment) => segment.tag_ids.includes(String(sampleTag?.id ?? -1)) === false,
      );

      return nonSampleSegments.length;
    },
    href: 'segments',
    modelId: 'people_rocket_added_segment_at',
  }),
] as const;
